(function () {
  function initFilterDrawer() {
    var toggle = document.getElementById('FilterDrawerToggle');
    var drawer = document.getElementById('FilterDrawer');
    var overlay = document.getElementById('FilterDrawerOverlay');
    var closeBtn = document.getElementById('FilterDrawerClose');
    if (!toggle || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.remove('hidden');
      toggle.setAttribute('aria-expanded', 'true');
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.add('hidden');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open'))
        closeDrawer();
    });

    // Close drawer when a filter is applied (checkbox/select input inside the drawer)
    drawer.addEventListener('input', function (e) {
      if (e.target.closest('#FacetFiltersForm')) {
        closeDrawer();
      }
    });

    // Close drawer when a facet-remove (reset/clear) link is clicked inside the drawer
    drawer.addEventListener('click', function (e) {
      var removeLink = e.target.closest('facet-remove a');
      if (removeLink) {
        closeDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFilterDrawer);
  } else {
    initFilterDrawer();
  }
})();
